import React from 'react';
import {
    Popper,
    Paper,
    ClickAwayListener,
    Grow,
    MenuList,
    MenuItem,
    makeStyles
} from '@material-ui/core';
import { PropTypes } from 'prop-types';
import { getTime } from '../../../utils/dateTimeUtil';
import { Age, Gender } from '../../UI';
const useStyle = makeStyles({
    rootList: {
        minWidth: '250px',
        maxHeight: '300px',
        overflowY: 'auto'
    },
    item: {
        display: 'block',
        borderBottom: 'solid 0.8px #f5f7fa',
        '&:hover': {
            borderRadius: '6px'
        }
    },
    patient: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    name: {
        fontWeight: '800'
    },
    time: {
        color: '#767676',
        borderRadius: '10px',
        backgroundColor: '#f5f7fa',
        fontSize: '10px',
        width: '42px',
        lineHeight: '19px',
        textAlign: 'center'
    },
    ageGender: {
        display: 'flex'
    },
    paperRoot: {
        zIndex: '999999',
        borderRadius: '10px',
        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
        background: '#fff',
        '& *': {
            zIndex: '999999'
        }
    },
    popper: {
        background: '#fff',
        borderRadius: '6px',
        zIndex: '999999'
    }
});
const AppointmentListMenu = ({ open, anchorEl, appointments, closeMenu, handleRedirect }) => {
    const classes = useStyle();
    const handleClose = () => {
        closeMenu();
    };
    return (
        <Popper
            className={classes.popper}
            open={open}
            anchorEl={anchorEl.current}
            role={undefined}
            transition
            disablePortal
        >
            {({ TransitionProps, placement }) => (
                <Grow
                    {...TransitionProps}
                    style={{
                        transformOrigin: placement === 'right' ? 'center left ' : 'center left'
                    }}
                >
                    <Paper classes={{ root: classes.paperRoot }}>
                        <ClickAwayListener onClickAway={handleClose}>
                            <MenuList classes={{ root: classes.rootList }}>
                                {appointments?.map((appointment) => (
                                    <MenuItem classes={{ root: classes.item }} key={appointment.id}>
                                        {appointment.patient && (
                                            <div
                                                className={classes.patient}
                                                onClick={() => handleRedirect(appointment)}
                                            >
                                                <div className={classes.name}>
                                                    {appointment?.patient.first_name}{' '}
                                                    {appointment?.patient.last_name}
                                                </div>
                                                <div className={classes.ageGender}>
                                                    <Age dob={appointment.patient.dob} />
                                                    <Gender
                                                        width={13}
                                                        gender={appointment.patient.gender}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        <div className={classes.time}>
                                            {getTime(appointment.appointed)}
                                        </div>
                                    </MenuItem>
                                ))}
                            </MenuList>
                        </ClickAwayListener>
                    </Paper>
                </Grow>
            )}
        </Popper>
    );
};
AppointmentListMenu.propTypes = {
    open: PropTypes.bool,
    anchorEl: PropTypes.any,
    appointments: PropTypes.array,
    closeMenu: PropTypes.func,
    handleRedirect: PropTypes.func
};
export default AppointmentListMenu;
